// Components that are related to PDF generation.
// Please keep the exports sorted to avoid merge conflicts.
import { defineAsyncComponent } from "vue";

export const PdfWrapper = defineAsyncComponent(async () => (await (import("./static/Pdf"))).PdfWrapper);
